import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=e0f774f6&scoped=true&"
var script = {}
import style0 from "./Privacy.vue?vue&type=style&index=0&id=e0f774f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f774f6",
  null
  
)

export default component.exports